<style lang="less">
@import "../../styles/variable.less";
.order-pdf-create-modal {
  .content {
    width: 550px;

    .main-content {
      padding: 20px 10px;
      border-bottom: solid 1px @clear-black02;
    }
    .child-content {
      padding: 20px 10px;
      border-bottom: solid 1px @clear-black02;
      .title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .child-card {
        margin-top: 5px;
      }
      .add-button {
        margin-top: 5px;
        width: 100%;
      }
    }
    .button-area {
      margin-top: 20px;
    }
  }
}
.order-pdf-preview-modal {
  .content {
    .image-area {
      display: flex;
      justify-content: center;
      .image {
        width: 100%;
        height: 540px;
        border: solid 1px @clear-black02;
        overflow: hidden;
      }
    }
    .button-area {
      margin-top: 20px;
    }
  }
}
</style>
<template>
  <div v-if="typesettingParam">
    <a-button
      size="large"
      type="primary"
      v-if="forTypesetting"
      @click="handleVisiblePdfCreate"
    >
      商品情報入力
    </a-button>
    <a-button
      size="large"
      type="primary"
      v-if="!forTypesetting"
      :disabled="!typesettingParam?.orderProduct?.files?.length"
      @click="handleVisiblePdfPreview"
    >
      PDFプレビュー
    </a-button>
    <a-modal
      v-if="!loading"
      class="order-pdf-create-modal"
      width="600px"
      title="商品情報入力"
      v-model:visible="visiblePdfCreate"
      :okButtonProps="{ style: 'display: none' }"
      :cancelButtonProps="{ style: 'display: none' }"
    >
      <div class="content">
        <a-form
          :model="typesettingParam"
          layout="horizontal"
          :labelCol="{ span: 8 }"
        >
          <div class="main-content">
            <a-form-item :label="$t('attributes.supplier_name')">
              <a-input
                v-model:value="typesettingParam.supplierName"
                @blur="handleUpdate"
              />
            </a-form-item>
            <!-- <a-form-item :label="$t('attributes.design_pattern_code')">
              <a-select
                v-model:value="typesettingParam.designPatternCode"
                :options="
                  designPatternCodes.map((val) => ({
                    value: val,
                    label: $t(`enums.design_pattern_code.${val}`),
                  }))
                "
                @change="handleUpdate"
              ></a-select>
            </a-form-item> -->
            <a-form-item :label="$t('attributes.product_name')">
              <a-input
                v-model:value="typesettingParam.productName"
                @blur="handleUpdate"
              />
            </a-form-item>
            <a-form-item :label="$t('attributes.jan_code')">
              <a-input
                v-model:value="typesettingParam.janCode"
                @blur="handleUpdate"
              />
            </a-form-item>
            <a-form-item :label="$t('attributes.tax_included_price')">
              <InputCurrency
                v-model:value="typesettingParam.taxIncludedPrice"
                @blur="handleUpdate"
              />
            </a-form-item>
            <!-- <a-form-item :label="$t('attributes.factory_product_code')">
              <a-input
                v-model:value="typesettingParam.factoryProductCode"
                @blur="handleUpdate"
              />
            </a-form-item> -->
            <a-form-item :label="$t('attributes.copyright_pattern_code')">
              <a-select
                v-model:value="typesettingParam.copyrightPatternCode"
                :options="
                  copyrightPatternCodes.map((val) => ({
                    value: val,
                    label: $t(`enums.copyright_pattern_code.${val}`),
                  }))
                "
                @change="handleUpdate"
              ></a-select>
            </a-form-item>
            <a-form-item :label="$t('attributes.country_of_origin')">
              <a-input
                v-model:value="typesettingParam.countryOfOrigin"
                @blur="handleUpdate"
              />
            </a-form-item>
            <a-form-item :label="$t('attributes.needle_detection_print_flag')">
              <a-checkbox
                v-model:checked="typesettingParam.needleDetectionPrintFlag"
                @change="handleUpdate"
              />
            </a-form-item>
            <a-form-item :label="$t('attributes.target_age_text')">
              <a-input
                v-model:value="typesettingParam.targetAgeText"
                @blur="handleUpdate"
              />
            </a-form-item>
            <a-form-item :label="$t('attributes.tracking_code')">
              <a-input
                v-model:value="typesettingParam.trackingCode"
                @blur="handleUpdate"
              />
            </a-form-item>
            <a-form-item :label="$t('attributes.three_circle_mark_flag')">
              <a-checkbox
                v-model:checked="typesettingParam.threeCircleMarkFlag"
                @change="handleUpdate"
              />
            </a-form-item>
          </div>

          <div class="child-content">
            <div class="title">注意書き文章</div>
            <div
              v-for="(
                warning, index
              ) in typesettingParam.typesettingParamWarnings"
              :key="warning.id"
              class="child-card"
            >
              <a-card size="small" :title="`注意書き文章${index + 1}`">
                <template v-slot:extra>
                  <a-space>
                    <!-- <a-button @click="handleVisibleWarningHeading(warning.id)" v-if="!warning.visibleHeading"
                      >見出し追加</a-button
                    >
                    <a-button @click="handleUnvisibleWarningHeading(warning.id)" v-if="warning.visibleHeading"
                      >見出し削除</a-button
                    > -->
                    <a-button @click="handleRemoveWarning(warning.id)"
                      >削除</a-button
                    >
                  </a-space>
                </template>
                <!-- <a-form-item v-if="warning.visibleHeading"> -->
                <a-form-item>
                  <a-input
                    v-model:value="warning.warningHeading"
                    @blur="handleUpdate"
                  />
                </a-form-item>
                <a-form-item>
                  <a-textarea
                    v-model:value="warning.warning"
                    @blur="handleUpdate"
                  />
                </a-form-item>
              </a-card>
            </div>
            <a-button @click="handleCreateWarning" class="add-button"
              >注意書き文章を追加</a-button
            >
          </div>
          <div class="child-content">
            <div class="title">サイズ</div>
            <a-form-item :label="$t('attributes.size_name')">
              <a-input
                v-model:value="typesettingParam.sizeName"
                @blur="handleUpdate"
              />
            </a-form-item>
            <div
              v-for="(size, index) in typesettingParam.typesettingParamSizes"
              :key="size.id"
              class="child-card"
            >
              <a-card size="small" :title="`サイズ成分${index + 1}`">
                <template v-slot:extra>
                  <a-space>
                    <a-button @click="handleRemoveSize(size.id)">削除</a-button>
                  </a-space>
                </template>
                <a-form-item :label="$t('attributes.size_component_name')">
                  <a-input
                    v-model:value="size.sizeComponentName"
                    @blur="handleUpdate"
                  />
                </a-form-item>
                <a-form-item :label="$t('attributes.size_component_value')">
                  <a-input
                    v-model:value="size.sizeComponentValue"
                    @blur="handleUpdate"
                  />
                </a-form-item>
              </a-card>
            </div>
            <a-button @click="handleCreateSize" class="add-button"
              >サイズ成分を追加</a-button
            >
          </div>

          <div class="child-content">
            <div class="title">素材</div>
            <a-form-item :label="$t('attributes.material_table_name')">
              <a-input
                v-model:value="typesettingParam.materialTableName"
                @blur="handleUpdate"
              />
            </a-form-item>
            <div
              v-for="(
                material, index
              ) in typesettingParam.typesettingParamMaterials"
              :key="material.id"
              class="child-card"
            >
              <a-card size="small" :title="`素材${index + 1}`">
                <template v-slot:extra>
                  <a-space>
                    <a-button @click="handleRemoveMaterial(material.id)"
                      >削除</a-button
                    >
                  </a-space>
                </template>
                <a-form-item :label="$t('attributes.material_heading')">
                  <a-input
                    v-model:value="material.materialHeading"
                    @blur="handleUpdate"
                  />
                </a-form-item>
                <a-form-item :label="$t('attributes.material_name')">
                  <a-input
                    v-model:value="material.materialName"
                    @blur="handleUpdate"
                  />
                </a-form-item>
                <a-form-item :label="$t('attributes.material_value')">
                  <InputPercent
                    v-model:value="material.materialValue"
                    @blur="handleUpdate"
                  />
                </a-form-item>
              </a-card>
            </div>
            <a-button @click="handleCreateMaterial" class="add-button"
              >素材を追加</a-button
            >
          </div>
          <div class="child-content">
            <div class="title">
              {{ $t("attributes.recycling_symbol_code") }}
            </div>
            <a-form-item>
              <a-input
                v-model:value="typesettingParam.recyclingSymbolCode"
                @blur="handleUpdate"
              />
            </a-form-item>
          </div>
        </a-form>

        <div class="button-area">
          <a-row type="flex" justify="end" :gutter="10">
            <a-col>
              <a-button size="large" @click="handleClose">閉じる</a-button>
            </a-col>
            <a-col>
              <a-button
                size="large"
                type="primary"
                @click="handleAutoTypesetting"
                >組版実行</a-button
              >
            </a-col>
          </a-row>
        </div>
      </div>
    </a-modal>

    <a-modal
      title="PDFプレビュー"
      width="650px"
      v-model:visible="visiblePdfPreview"
      :footer="null"
      class="order-pdf-preview-modal"
    >
      <div class="content">
        <div class="image-area">
          <!-- 新しい順に取得しているため、filesの先頭で良い -->
          <embed
            :src="`${typesettingParam?.orderProduct?.files[0]?.originalPath}#zoom=140`"
            class="image"
          />
        </div>
        <div class="button-area">
          <a-row type="flex" justify="end" :gutter="10">
            <a-col v-if="!previewOnly">
              <a-button size="large" @click="handleVisiblePdfCreate">
                組版情報を再設定
              </a-button>
            </a-col>
            <a-col v-if="!previewOnly">
              <a-button size="large" @click="handleEditpdf"
                >PDFを手修正</a-button
              >
            </a-col>
            <a-col>
              <a-button size="large" type="primary" @click="handleClose">{{
                previewOnly ? "閉じる" : "完了"
              }}</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs, onMounted, unref } from "vue";
import { clone, parseError } from "@/generic";
import {
  CopyrightPatternCode,
  DesignPatternCode,
  TypesettingParamSize,
  TypesettingParamMaterial,
  TypesettingParamWarning,
} from "@/client/schema";
import {
  useUpdateOneTypesettingParamMutation,
  useGetOneTypesettingParamQuery,
  useCreateOneTypesettingParamSizeMutation,
  useRemoveOneTypesettingParamSizeMutation,
  useCreateOneTypesettingParamMaterialMutation,
  useRemoveOneTypesettingParamMaterialMutation,
  useCreateOneTypesettingParamWarningMutation,
  useRemoveOneTypesettingParamWarningMutation,
  useCreateAutoTypesettingMutation,
  useUpdateAutoTypesettingMutation,
} from "@/client/modules/api";
import { useGetSession } from "@/client/modules/session";
import { InputCurrency, InputPercent } from "@/generic/components/entry";

export type Props = {
  typesettingParamId: string;
  forTypesetting: boolean;
  previewOnly: boolean;
  typesettingPreviewFlag: boolean;
};

const fallbackImage =
  "data:image/png;base64,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";

export default defineComponent({
  components: {
    InputCurrency,
    InputPercent,
  },
  props: {
    typesettingParamId: {
      type: String,
      required: true,
    },
    forTypesetting: {
      type: Boolean,
      required: false,
      default: false,
    },
    previewOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    typesettingPreviewFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["change"],
  setup(props: Props) {
    const state = reactive({
      typesettingParam: null as null | any,
      visiblePdfCreate: false,
      visiblePdfPreview: true,
      editPdfPath: null as null | string,
      errorMessages: [] as string[],
      creating: false,
      removing: false,
    });

    const { loading, onResult, refetch } = useGetOneTypesettingParamQuery(
      {
        id: props.typesettingParamId,
      },
      {
        fetchPolicy: "network-only",
      }
    );
    onResult((result) => {
      state.typesettingParam = clone(result.data.typesettingParam);
      state.typesettingParam.typesettingParamWarnings?.forEach(
        (warning: any) => {
          warning.visibleHeading = true;
        }
      );
    });

    const copyrightPatternCodes = Object.values(CopyrightPatternCode);
    const designPatternCodes = Object.values(DesignPatternCode);

    const handleVisiblePdfCreate = () => {
      state.visiblePdfCreate = true;
      state.visiblePdfPreview = false;
    };

    const handleVisiblePdfPreview = () => {
      state.visiblePdfCreate = false;
      state.visiblePdfPreview = true;
    };

    const { mutate: createAutoTypesetting, error: createHxError } =
      useCreateAutoTypesettingMutation({});
    const handleAutoTypesetting = async () => {
      try {
        handleUpdate();
        if (state.typesettingParam?.orderProduct == null) return;
        await createAutoTypesetting({
          input: {
            id: state.typesettingParam.orderProduct.id,
          },
        });
        state.visiblePdfCreate = false;
        state.visiblePdfPreview = true;
      } catch (e) {
        if (createHxError.value == null) throw e;
        state.errorMessages = parseError(createHxError);
      }
    };

    const { currentUser } = useGetSession();
    const { mutate: updateAutoTypesetting, error: updateHxError } =
      useUpdateAutoTypesettingMutation({});
    const handleEditpdf = async () => {
      try {
        if (state.typesettingParam?.orderProduct == null) return;
        const result = await updateAutoTypesetting({
          input: {
            id: state.typesettingParam.orderProduct.id,
          },
        });
        const data = result?.data?.updateAutoTypesetting;
        if (data) {
          const fileKey = data.fileKey;
          const clientUserId = unref(currentUser).id;
          const orderProductId = state.typesettingParam.orderProduct.id;
          const backUrl = `${location.origin}/api/app/sonbp_callback/${fileKey}/${clientUserId}/${orderProductId}`;
          const editPdfParams: { [key: string]: any } = {};
          editPdfParams["access_token"] = data.accessToken;
          editPdfParams["file_key"] = fileKey;
          editPdfParams["back_url"] = backUrl;
          const editPdfQuery = new URLSearchParams(editPdfParams);
          const editPdfPath = `${data.sonbpUri}?${editPdfQuery}`;
          window.location.href = editPdfPath;
        }
      } catch (e) {
        if (updateHxError.value == null) throw e;
        state.errorMessages = parseError(updateHxError);
      }
    };

    onMounted(() => {
      state.visiblePdfPreview = props.typesettingPreviewFlag;
    });

    const { mutate: update, error: updateError } =
      useUpdateOneTypesettingParamMutation({});

    const handleUpdate = async () => {
      const safeTypesettingParam = state.typesettingParam;
      try {
        if (safeTypesettingParam == null) return;
        state.errorMessages = [];
        await update({
          input: {
            id: props.typesettingParamId,
            supplierName: safeTypesettingParam.supplierName,
            productName: safeTypesettingParam.productName,
            factoryProductCode: safeTypesettingParam.factoryProductCode,
            janCode: safeTypesettingParam.janCode,
            taxIncludedPrice: safeTypesettingParam.taxIncludedPrice,
            trackingCode: safeTypesettingParam.trackingCode,
            targetAgeText: safeTypesettingParam.targetAgeText,
            needleDetectionPrintFlag:
              safeTypesettingParam.needleDetectionPrintFlag,
            copyrightPatternCode: safeTypesettingParam.copyrightPatternCode,
            countryOfOrigin: safeTypesettingParam.countryOfOrigin,
            recyclingSymbolCode: safeTypesettingParam.recyclingSymbolCode,
            threeCircleMarkFlag: safeTypesettingParam.threeCircleMarkFlag,
            sizeName: safeTypesettingParam.sizeName,
            materialTableName: safeTypesettingParam.materialTableName,
            typesettingParamSizes:
              safeTypesettingParam.typesettingParamSizes?.map(
                (size: TypesettingParamSize) => ({
                  id: size.id,
                  sizeComponentName: size.sizeComponentName || null,
                  sizeComponentValue: size.sizeComponentValue || null,
                })
              ),
            typesettingParamMaterials:
              safeTypesettingParam.typesettingParamMaterials?.map(
                (material: TypesettingParamMaterial) => ({
                  id: material.id,
                  materialHeading: material.materialHeading || null,
                  materialName: material.materialName || null,
                  materialValue: material.materialValue || null,
                })
              ),
            typesettingParamWarnings:
              safeTypesettingParam.typesettingParamWarnings?.map(
                (warning: TypesettingParamWarning) => ({
                  id: warning.id,
                  warningHeading: warning.warningHeading || null,
                  warning: warning.warning || null,
                })
              ),
          },
        });

        await refetch();
      } catch (e) {
        if (updateError.value == null) throw e;
        state.errorMessages = parseError(updateError.value);
      }
    };

    const handleClose = () => {
      state.visiblePdfCreate = false;
      state.visiblePdfPreview = false;
    };

    const { mutate: createSize, error: createSizeError } =
      useCreateOneTypesettingParamSizeMutation({});
    const handleCreateSize = async () => {
      if (state.creating) return;
      try {
        state.creating = true;
        await createSize({
          input: {
            typesettingParamId: props.typesettingParamId,
          },
        });

        await refetch();
      } catch (e) {
        if (createSizeError.value == null) throw e;
        state.errorMessages = parseError(createSizeError);
      } finally {
        state.creating = false;
      }
    };

    const { mutate: removeSize, error: removeSizeError } =
      useRemoveOneTypesettingParamSizeMutation({});
    const handleRemoveSize = async (sizeId: string) => {
      if (state.removing) return;
      try {
        state.removing = true;
        await removeSize({
          input: {
            id: sizeId,
          },
        });

        await refetch();
      } catch (e) {
        if (removeSizeError.value == null) throw e;
        state.errorMessages = parseError(removeSizeError);
      } finally {
        state.removing = false;
      }
    };

    const { mutate: createMaterial, error: createMaterialError } =
      useCreateOneTypesettingParamMaterialMutation({});
    const handleCreateMaterial = async () => {
      if (state.creating) return;
      try {
        state.creating = true;
        await createMaterial({
          input: {
            typesettingParamId: props.typesettingParamId,
          },
        });

        await refetch();
      } catch (e) {
        if (createMaterialError.value == null) throw e;
        state.errorMessages = parseError(createMaterialError);
      } finally {
        state.creating = false;
      }
    };

    const { mutate: removeMaterial, error: removeMaterialError } =
      useRemoveOneTypesettingParamMaterialMutation({});
    const handleRemoveMaterial = async (sizeId: string) => {
      if (state.removing) return;
      try {
        state.removing = true;
        await removeMaterial({
          input: {
            id: sizeId,
          },
        });

        await refetch();
      } catch (e) {
        if (removeMaterialError.value == null) throw e;
        state.errorMessages = parseError(removeMaterialError);
      } finally {
        state.removing = false;
      }
    };

    const { mutate: createWarning, error: createWarningError } =
      useCreateOneTypesettingParamWarningMutation({});
    const handleCreateWarning = async () => {
      if (state.creating) return;
      try {
        state.creating = true;
        const result = await createWarning({
          input: {
            typesettingParamId: props.typesettingParamId,
          },
        });

        await refetch();
        const warningId =
          result?.data?.createOneTypesettingParamWarning
            ?.typesettingParamWarning?.id;
        const warning = state.typesettingParam.typesettingParamWarnings?.filter(
          (warning: any) => warning.id == warningId
        );
        warning.visibleHeading = false;
      } catch (e) {
        if (createWarningError.value == null) throw e;
        state.errorMessages = parseError(createWarningError);
      } finally {
        state.creating = false;
      }
    };

    // const handleVisibleWarningHeading = (warningId: string) => {
    //   const warning = state.typesettingParam.typesettingParamWarnings?.filter((warning: any) => warning.id == warningId);
    //   warning.visibleHeading = true;
    // };

    // const handleUnvisibleWarningHeading = (warningId: string) => {
    //   const warning = state.typesettingParam.typesettingParamWarnings?.filter((warning: any) => warning.id == warningId)
    //   warning.visibleHeading = false;
    //   warning.warningHeading = null;
    // };

    const { mutate: removeWarning, error: removeWarningError } =
      useRemoveOneTypesettingParamWarningMutation({});
    const handleRemoveWarning = async (sizeId: string) => {
      if (state.removing) return;
      try {
        state.removing = true;
        await removeWarning({
          input: {
            id: sizeId,
          },
        });

        await refetch();
      } catch (e) {
        if (removeWarningError.value == null) throw e;
        state.errorMessages = parseError(removeWarningError);
      } finally {
        state.removing = false;
      }
    };

    return {
      fallbackImage,
      ...toRefs(state),
      loading,
      copyrightPatternCodes,
      designPatternCodes,
      handleVisiblePdfCreate,
      handleVisiblePdfPreview,
      handleAutoTypesetting,
      handleEditpdf,
      handleUpdate,
      handleClose,
      handleCreateSize,
      handleRemoveSize,
      handleCreateMaterial,
      handleRemoveMaterial,
      handleCreateWarning,
      handleRemoveWarning,
      // handleVisibleWarningHeading,
      // handleUnvisibleWarningHeading,
    };
  },
});
</script>
